// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"vp-z","imageAndVideoCount":"wp-z","imageAndVideoContainer":"xp-z","viewAllReviews":"yp-z"};